<template>
	<!-- Leaf story / external link, styled like the old Storyblok MenuLink items. -->
	<NuxtLink
		v-if="cmsLeaf && !hasChildren && node.type !== 'category'"
		:to="resolveHref(node)"
		class="nav-link nav-link-cms text-xs uppercase tracking-[0.9px] cursor-pointer border-b px-4 block py-3"
		@click="emit('close')"
	>
		{{ node.name }}
	</NuxtLink>
	<div v-else class="flex justify-between items-center border-b px-4 py-3">
		<button
			v-if="hasChildren"
			type="button"
			class="flex-grow text-left"
			@click="emit('open', node)"
		>
			{{ node.name }}
		</button>
		<NuxtLink
			v-else
			:to="resolveHref(node)"
			class="flex-grow"
			@click="emit('close')"
		>
			{{ node.name }}
		</NuxtLink>
		<ChevronRightIcon v-if="hasChildren" class="h-6 w-6" aria-hidden="true" />
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import type { ResolvedMenuNode } from "~/types/storyblok/storyblok";

interface Props {
	node: ResolvedMenuNode;
	/** Top level only: render a childless story/external node as a MenuLink-style link. */
	cmsLeaf?: boolean;
}

const { node, cmsLeaf = false } = defineProps<Props>();

const emit = defineEmits<{
	open: [node: ResolvedMenuNode];
	close: [];
}>();

const { resolveMenuHref: resolveHref } = useStoryblokLink();
const hasChildren = computed(() => node.children.length > 0);
</script>
